<template>
  <div id="home">
    <div class="events">
      <div class="welcome_msg">
        <span v-html="$t('volunteers.welcome_msg.main')"></span>
      </div>
      <div class="title">
        <h2>{{ $t("titles.upcoming_events") }}</h2>
      </div>

      <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
          <v-flex
            xs6
            md6
            class="event"
            v-for="(event, key) in events_active"
            :key="key"
            v-if="event && parseInt(event.volunteer_visible) == 1"
          >
            <v-card>
              <div class="go"></div>
              <div class="logo" :style="'background-color:' + event.color">
                <img :src="event.img" />
              </div>
              <v-card-title primary-title>
                <div class="content">
                  <div class="title">
                    <h3 class="headline mb-0">{{ event.name }}</h3>
                    <span class="date">{{
                      event.start_date + " - " + event.end_date
                    }}</span>
                  </div>
                  <div
                    class="subtitle"
                    v-if="!event.joined"
                    @click="joinEvent(event)"
                  >
                    <strong>{{ $t("params.join") }} </strong>
                  </div>
                  <div
                    class="subtitle"
                    v-else-if="event.joined == 15"
                    @click="joinEvent(event)"
                  >
                    {{ $t("params.join_modify") }} |
                    <strong>
                      {{ $t(status_joined(event.joined)) }}
                    </strong>
                  </div>
                  <div
                    class="subtitle"
                    v-else-if="event.joined == 16"
                    @click="goToEvent(event.id)"
                  >
                    <strong>
                      {{ $t("params.access") }} |
                      {{ $t(status_joined(event.joined)) }}
                    </strong>
                  </div>
                  <div class="subtitle" v-else-if="event.joined == 17">
                    <strong>
                      {{ $t(status_joined(event.joined)) }}
                    </strong>
                  </div>
                </div>
              </v-card-title>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>

      <!-- JOIN EVENT POPUP -->
      <v-dialog
        persistent
        v-model="joiningEvent"
        :width="isMobile ? '100%' : '55%'"
        id="join_popup"
      >
        <v-card class="join popup" style="height: 100%">
          <v-card-title
            class="headline grey lighten-2"
            primary-title
            style="padding: 8px 10px; font-size: 20px !important"
            >{{ "params.join_event" | i18n }}
            {{ eventToJoin.name }}
          </v-card-title>

          <v-card-text
            style="padding: 8px 10px; margin-top: 10px; min-height: 300px"
          >
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-container>
                    <v-flex xs12 md12 lg12 xl12>
                      <div class="item" style="width: 95%">
                        <div class="info">{{ $t("params.which_event") }}</div>
                        <label>{{ $t("params.we_try") }}</label>
                        <span class="obligatory" v-if="error.event_role">{{
                          $t("params.event_role_undefined")
                        }}</span>
                        <v-layout row wrap class="box mobile-box">
                          <v-flex xs12 md6 lg6 xl6>
                            <v-select
                              ref="homeJoinEventRoleSelect"
                              class="event_role"
                              :class="error.event_role ? 'error' : ''"
                              v-model="joiningEventInfo.role"
                              :items="
                                basketReferee.indexOf(eventToJoin.id) == -1 ||
                                basketReferee.length == 0
                                  ? roleRefereeFiltered
                                  : roleParent
                              "
                              :item-text="
                                (item) =>
                                  $t('role_volunteer_event.' + item.name)
                              "
                              item-value="id"
                              multiple
                              clearable
                              @change="checkOthers('event')"
                            >
                              <template v-slot="data">
                                <span
                                  v-if="
                                    data.item.name == 'referee_category' &&
                                    (basketReferee.indexOf(eventToJoin.id) ==
                                      -1 ||
                                      basketReferee.length == 0)
                                  "
                                >
                                </span>
                                <span v-else>
                                  {{
                                    $t("role_volunteer_event." + data.item.name)
                                  }}
                                </span>
                              </template>

                              <template v-slot:selection="data">
                                <v-chip :selected="data.selected">
                                  {{
                                    $t("role_volunteer_event." + data.item.name)
                                  }}
                                </v-chip>
                              </template>
                            </v-select>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>

                    <v-flex xs12 md12 lg12 xl12 v-if="otherFotoVideo">
                      <div class="item" style="width: 95%">
                        <label>{{ $t("params.reference") }}</label>
                        <div class="info">
                          {{ $t("volunteer_form_literals.foto_description") }}
                        </div>
                        <v-layout
                          row
                          wrap
                          v-for="(item, index) in joiningEventInfo.rrss"
                        >
                          <v-flex xs12 md6 lg6 xl6>
                            <div class="item">
                              <input
                                class="upper shadow rrss"
                                type="text"
                                v-model="item.url"
                              />
                            </div>
                          </v-flex>

                          <v-flex
                            xs1
                            md1
                            lg1
                            xl1
                            class="icon"
                            style="padding-top: 10px"
                          >
                            <v-icon
                              v-if="joiningEventInfo.rrss.length > 1"
                              @click="joiningEventInfo.rrss.splice(index, 1)"
                              >remove</v-icon
                            >
                            <v-icon
                              v-if="
                                index == joiningEventInfo.rrss.length - 1 &&
                                joiningEventInfo.rrss.length < 7
                              "
                              @click="joiningEventInfo.rrss.push({ url: '' })"
                              >add</v-icon
                            >
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>

                    <v-flex xs12 md12 lg12 xl12 v-if="otherReferee">
                      <v-layout row wrap>
                        <v-flex xs12 md6 lg6 xl6>
                          <div class="item">
                            <label
                              >{{ $t("params.referee_experience") }}
                            </label>
                            <div class="info">
                              {{
                                $t(
                                  "volunteer_form_literals.referee_description"
                                )
                              }}
                            </div>
                            <textarea
                              class="shadow"
                              v-model="joiningEventInfo.referee_experience"
                            ></textarea>
                          </div>
                        </v-flex>
                        <v-flex xs12 md6 lg6 xl6>
                          <div class="item">
                            <label>{{ $t("params.3po") }} </label>
                            <v-select
                              ref="homeReferee3poSelect"
                              v-model="joiningEventInfo.referee3po"
                              :items="Object.values(volunteer_3po_options)"
                              :item-text="
                                (item) =>
                                  $t('volunteer_form_literals.3po_' + item.name)
                              "
                              item-value="id"
                            >
                              <template v-slot:selection="data">
                                <v-chip :selected="data.selected">
                                  {{
                                    $t(
                                      "volunteer_form_literals.3po_" +
                                        data.item.name
                                    )
                                  }}
                                </v-chip>
                              </template>
                            </v-select>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex
                      xs12
                      md12
                      lg12
                      xl12
                      v-if="
                        eventToJoin.type == 'Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09'
                      "
                    >
                      <v-btn
                        color="#e0e0e0"
                        style="color: #000 !important; padding: 0 10px"
                        class="white--text"
                        @click="openMoreInfo"
                      >
                        {{ $t("more_information") }}
                        <v-icon right dark>info</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-btn color="primary" flat @click="close()">{{
              `cancel` | i18n
            }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click="save()">{{
              `confirm` | i18n
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import vuetifySelectOutsideClick from "@/mixins/vuetifySelectOutsideClick";

export default {
  name: "Home",
  mixins: [vuetifySelectOutsideClick],
  data() {
    return {
      joiningEvent: false,
      joiningEventInfo: {
        rrss: [{ url: "" }],
      },
      eventToJoin: {},
      otherFotoVideo: false,
      otherReferee: false,
      error: {
        event: false,
        event_role: false,
      },
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },

    user() {
      return this.$store.getters["getUser"];
    },

    events_active() {
      var aEvents = this.$store.getters["events/getActives"];
      var aResult = [];
      var self = this;

      if (aEvents) {
        var self = this;
        Object.values(aEvents).forEach((event) => {
          aResult.push({
            id: event.id,
            name: self.$root.formatEventName(event.name, event.edition),
            img: event.logo,
            type: event.event_type,
            start_date: moment(event.start_date).format("DD/MM/YYYY"),
            end_date: moment(event.end_date).format("DD/MM/YYYY"),
            color: self.events_type[event.event_type]
              ? self.events_type[event.event_type].color
              : "#000",
            joined: self.user.events[event.id]
              ? parseInt(self.user.events[event.id].status)
              : false,
            volunteer_visible: event.volunteer_visible,
          });
        });
      }
      return aResult;
    },

    events_type() {
      return this.$store.getters.getEventsType;
    },

    role_volunteer() {
      return this.$store.getters.getRoleVolunteer;
    },

    roleParent() {
      return Object.values(this.role_volunteer).filter(
        (item) => item.parent_id == null && item.status == 1
      );
    },

    roleChildren() {
      return Object.values(this.role_volunteer).filter(
        (item) => item.parent_id != null && item.status == 1
      );
    },

    roleRefereeFiltered() {
      // ROLES WITHOUT REFEREE
      var result = { ...this.role_volunteer };

      var referee = Object.values(this.role_volunteer).find((obj) => {
        return obj.name == "referee_category";
      });

      if (referee) {
        delete result[referee.id];
      }

      return Object.values(result).filter(
        (item) => item.parent_id == null && item.status == 1
      );
    },

    basketReferee() {
      var basket = Object.values(this.events_active).find((obj) => {
        return obj.name == "MICBasketball";
      });

      var positions = [];

      if (basket) {
        for (var item in this.volunteer.event) {
          if (this.volunteer.event[item].id.indexOf(basket.id) > -1) {
            positions.push(parseInt(item));
          }
        }
      }

      return positions;
    },
  },
  created() {
    var self = this;
    this.$overlay.loading();
    this.$store.dispatch("persons/getVolunteer", this.user).then(() => {
      self.$store.dispatch("loadTablesRelationship").then(function () {
        self.$store.dispatch("events/loadActives", {}).then(() => {
          self.$overlay.hide();
        });
      });
    });
  },
  methods: {
    getVuetifyOutsideClickSelectRefs() {
      return ["homeJoinEventRoleSelect", "homeReferee3poSelect"];
    },

    goToEvent(key) {
      this.$router.push({ name: "event", params: { event_id: key } });
    },

    joinEvent(event) {
      this.eventToJoin = { ...event };
      const person = JSON.parse(
        JSON.stringify(
          this.$store.getters["persons/get_by_id"](this.user.person_id)
        )
      );
      if (this.user.events[event.id]) {
        let aux_ev = {};
        person.event.forEach((ev) => {
          if (event.id == ev.id) {
            aux_ev = JSON.parse(JSON.stringify(ev));
          }
        });

        this.joiningEventInfo = {
          role: aux_ev.role,
          rrss: person.rrss
            ? typeof person.rrss === "string"
              ? JSON.parse(person.rrss)
              : person.rrss
            : [{ url: "" }],
        };
      } else {
        this.joiningEventInfo = {
          rrss: person.rrss
            ? typeof person.rrss === "string"
              ? JSON.parse(person.rrss)
              : person.rrss
            : [{ url: "" }],
        };
      }
      this.joiningEvent = true;
      this.checkOthers("event");
    },

    openMoreInfo() {
      if (this.eventToJoin.type == "Z1NjenJhTWxQSmdjVkYwVG1JMVMrZz09") {
        const lang = this.$store.getters["user/getLanguage"];
        const link =
          process.env.VUE_APP_APP_URL +
          "files/VOLUNTARIS_MICFOOTBALL_" +
          lang.toUpperCase() +
          ".pdf?" +
          moment().valueOf();
        window.open(link, "_blank");
      }
    },

    close() {
      this.joiningEvent = false;
      this.eventToJoin = {};
    },

    save() {
      var self = this;
      var params = {};
      params.id = this.user.person_id;
      params.event_id = this.eventToJoin.id;

      this.error.event_role = false;
      if (Object.keys(this.joiningEventInfo.role).length == 0) {
        this.error.event_role = true;
        return;
      } else this.error.event_role = false;

      params.event = JSON.stringify({
        id: this.eventToJoin.id,
        role: this.joiningEventInfo.role,
      });
      params.rrss = JSON.stringify(this.joiningEventInfo.rrss);

      this.$overlay.loading();
      this.$store
        .dispatch("persons/addRelationToEvent", params)
        .then((response) => {
          self.joiningEvent = false;
          window.location.reload();
        });
    },

    checkOthers(name) {
      // Check in event select
      if (name == "event") {
        // Check if user selects "Àrbitre"
        this.otherReferee = false;
        for (var role in this.joiningEventInfo.role) {
          if (
            this.role_volunteer[this.joiningEventInfo.role[role]].name.includes(
              "referee"
            )
          ) {
            this.otherReferee = true;
            break;
          } else {
            this.otherReferee = false;
          }
        }

        // Check if user selects "Foto | Vídeo"
        this.otherFotoVideo = false;
        for (var role in this.joiningEventInfo.role) {
          if (
            this.role_volunteer[this.joiningEventInfo.role[role]].name.includes(
              "marketing_communication"
            )
          ) {
            this.otherFotoVideo = true;
            break;
          } else {
            this.otherFotoVideo = false;
          }
        }
      }
    },

    status_joined(value) {
      if (value) {
        const status_joined =
          this.$store.getters["events/getStatusEntityByID"](value);
        return status_joined ? status_joined.name : "";
      }
      return "";
    },
  },
  filters: {},
};
</script>

<style lang="scss" scoped>
#home {
  .section-list {
    width: 100%;
    position: relative;
    overflow: hidden;
    text-align: center;

    a {
      text-decoration: none;
    }

    .section {
      width: 125px;
      height: 125px;
      display: inline-block;
      margin: 0px 10px;
      margin-bottom: 35px;
      position: relative;
      text-align: center;

      .icon {
        width: 80%;
        height: 80%;
        border-radius: 50%;
        padding: 20px;
        position: relative;
        display: inline-block;
        background-color: #222;
        border: 5px solid tint(#222, 70%);
        -webkit-transition: border 200ms ease-out;
        -moz-transition: border 200ms ease-out;
        -o-transition: border 200ms ease-out;
        transition: border 200ms ease-out;

        &.disabled {
          opacity: 0.5;
        }

        .add {
          width: 30px;
          height: 30px;
          background: url("/img/add_2.svg");
          background-color: $complem-color;
          border-radius: 50%;
          border: 1px solid var(--main-color);
          position: absolute;
          top: -5px;
          right: -5px;
          content: " ";
          background-size: 20px;
          background-position: center;
          background-repeat: no-repeat;
          -webkit-transition: all 200ms ease-out;
          -moz-transition: all 200ms ease-out;
          -o-transition: all 200ms ease-out;
          transition: all 200ms ease-out;

          &:hover {
            width: 35px;
            height: 35px;
          }
        }

        &:hover {
          border: 8px solid tint(#222, 70%);
        }

        img {
          position: absolute;
          height: 50%;
          width: auto;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .content {
        width: 100%;
        color: #192461;
        height: 30px;
        line-height: 30px;
        font-size: 18px;
        text-align: center;
        font-family: $text-light;
      }
    }
  }

  .events {
    margin-top: 50px;

    .title {
      h1 {
        font-size: 32px !important;
        text-align: center;
      }
    }

    .event {
      padding: 12px;

      .go {
        content: " ";
        width: 30px;
        height: 30px;
        background-image: url("/img/right-arrow.svg");
        background-size: 30px;
        background-position: center;
        position: absolute;
        top: 10px;
        right: 10px;
        display: none;
      }

      .logo {
        width: 100%;
        height: 85px;
        text-align: center;

        &.e1 {
          background-color: $main-color-e1;
        }
        &.e2 {
          background-color: $main-color-e2;
        }
        &.e3 {
          background-color: $main-color-e3;
        }
        &.e4,
        &.e12 {
          background-color: $main-color-e4;
        }
        &.e5 {
          background-color: $main-color-e5;
        }
        &.e13 {
          background-color: $main-color-e13;
        }

        img {
          height: 75px;
          width: auto;
          margin: 5px 0;
        }
      }

      .content {
        width: 100%;
        padding: 20px;

        .title {
          text-align: center;

          .headline {
            padding-left: 0;
            font-family: $title-bold !important;
            text-align: center;
          }
        }

        .subtitle {
          font-weight: lighter;
          text-align: center;
          font-size: 14px;
          cursor: pointer;
          margin-top: 10px;

          strong {
            font-size: 18px;
            font-weight: bold;
          }
        }

        .stats {
          .stat {
            display: inline-block;
            text-align: center;

            .icon {
              height: 35px;
              text-align: center;
              background-color: #eee;
              padding: 10px;
              border-radius: 100%;
              width: 35px;
              margin: 0 auto;

              img {
                height: 15px;
                opacity: 0.2;
              }
            }
            .label {
              font-size: 12px;
              font-weight: lighter;
              text-align: center;
            }

            .value {
              margin-top: 5px;
              font-size: 25px;
              color: #acacac;
              line-height: 24px;
              text-align: center;

              .success {
                color: #000;
                font-weight: bold;
                font-size: 22px;
              }
            }

            &:not(:first-child) {
              border-left: 1px solid #ddd;
            }
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#join_popup.v-dialog {
  height: 550px !important;
}

.v-dialog {
  input.rrss {
    width: 100% !important;
    border-bottom: 2px solid #dddddd !important;
  }
}
</style>

<style lang="scss" scoped>
@media only screen and (max-width: 600px) {
  .headline {
    font-size: 14px !important;
  }
  .date {
    font-size: 12px !important;
  }

  .subtitle {
    font-size: 14px !important;
  }
}
</style>
